module.exports = __webpack_public_path__ + "img/pandarena-m-90.25797bc5.gif";